import { Box } from 'grommet';
import { observer } from 'mobx-react-lite';
import { AddNewButton } from '../../AddNewButton';
import { useMemo, useState } from 'react';
import { CreateUsageEstimateModal } from '..';
// import { UsageEstimatePanel } from './UsageEstimatePanel';
import { UsageEstimatePanel } from './UsageEstimatePanel';
import { Commercial, EstimateStatus, TCommercialId } from '@talon/web/lib/api';
import { useEstimateStore } from '@talon/web/src/context';
import { byPosition } from '@talon/web/src/utils/stableOrder';
import { EmptyState } from '@talon/web/src/components/ui/EmptyState';

export interface IUsageEstimateListProps {
  commercial: Commercial;
}

export const UsageEstimateList = observer(() => {
  /** Context **/
  const estimateStore = useEstimateStore();

  /** State **/
  const [showAddModal, setShowAddModal] = useState(false);

  /** Computed **/
  const canEdit = estimateStore.canEditCurrent;
  const isDraft = estimateStore.currentEstimate?.status === EstimateStatus.Draft;

  const usageEstimates = useMemo(() => {
    const items = estimateStore.currentEstimate?.usage_estimates;
    return items && [...items].sort(byPosition);
  }, [estimateStore.currentEstimate?.usage_estimates]);

  /** Methods **/
  const addUsageEstimate = async (title: string, commercialId?: TCommercialId) => {
    if (!estimateStore.currentEstimate) return;

    await estimateStore.createUsageEstimate(title, commercialId);
  };

  /** Render **/
  return (
    <Box gap="small" margin={{ horizontal: 'small', bottom: 'medium' }} pad="small">
      {isDraft && canEdit && (
        <Box alignSelf="end" pad={{ vertical: 'xsmall' }} margin={{ left: 'medium' }}>
          <AddNewButton secondary label="Add usage estimate" onClick={() => setShowAddModal(true)} />
        </Box>
      )}
      <Box align="center">
        {!!usageEstimates?.length &&
          usageEstimates.map((usageEstimate) => (
            <UsageEstimatePanel key={usageEstimate.id} usageEstimate={usageEstimate} />
          ))}
        {!usageEstimates?.length && (
          <EmptyState
            title="No usage estimates yet"
            body="Add one for each commercial whose usage you want priced in this estimate."
            actionLabel={isDraft && canEdit ? 'Add usage estimate' : undefined}
            onAction={() => setShowAddModal(true)}
          />
        )}
      </Box>
      {isDraft && showAddModal && (
        <CreateUsageEstimateModal addUsageEstimate={addUsageEstimate} setShowModal={setShowAddModal} />
      )}
    </Box>
  );
});
